import React, {Component} from 'react';
import {Row, Cell} from './tableUtils';
import css from './usersTable.scss';
import Popup from '../popup/popup';
import SelectGroup from '../selectGroup/selectGroup';
import {Mutation} from 'react-apollo';
import {CREATE_USER, GET_USERS} from './queries';

class CreateUser extends Component {
	state = {
		firstname: '',
		lastname: '',
		email: '',
		group: null,
		enabled: false,
	};
	updateState = e => {
		let state = {};
		state[e.target.name] = e.target.value;
		if (e.target.type === 'checkbox') {
			return;
		}
		this.setState(_ => state);
	};
	setGroup = groupId => {
		this.setState(_ => ({group: groupId}), _ => console.log(this.state.group));
	};
	updateCache = (cache, {data: {user}}) => {
		const data = cache.readQuery({query: GET_USERS});
		user.enabled = false;
		data.users.push(user);
		cache.writeQuery({query: GET_USERS, data});
		this.setState(_ => ({
			firstname: '',
			lastname: '',
			email: '',
			group: null,
		}));
		this.selectGroup.reset();
	};
	render() {
		return (
			<Mutation
				mutation={CREATE_USER}
				variables={this.state}
				update={this.updateCache}
			>
				{(addUser, {loading, error}) => (
					<form
						className={css.form + (loading ? ' loading' : '')}
						onSubmit={e => {
							e.preventDefault();
							addUser();
						}}
					>
						<Row>
							<Cell type="deleteCol">
								<button className={css.confirm} type="submit" />
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom"
									name="lastname"
									onChange={this.updateState}
									value={this.state.lastname}
									required
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Prénom"
									name="firstname"
									onChange={this.updateState}
									value={this.state.firstname}
									required
								/>
							</Cell>
							<Cell type="email">
								<input
									type="email"
									placeholder="Email"
									name="email"
									onChange={this.updateState}
									value={this.state.email.toLowerCase()}
									required
								/>
							</Cell>
							<Cell type="group" center>
								<SelectGroup
									ref={n => this.selectGroup = n}
									group={this.state.groupObj}
									onSelect={e => this.setGroup(e)}
								/>
							</Cell>
							<Cell type="enable" />
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]}
								</Popup>
							)}
						</Row>
						<input type="submit" className={css.hidden} />
					</form>
				)}
			</Mutation>
		);
	}
}

export default CreateUser;



// WEBPACK FOOTER //
// ./src/usersTable/createUser.js